import { IVotingDetailResult } from "src/components/common/voting/types";
import { API_VOTE_USER_URL } from "src/constants/urls";
import { useMutation } from "src/lib/tanstack-query/hooks/use-mutation";
import { IErrorResponse } from "./types";
import { IVoteUserRequest } from "./vote-user.api.types";

export const useVoteUser = () => {
    const { mutate } = useMutation<IVotingDetailResult, IErrorResponse, IVoteUserRequest>(API_VOTE_USER_URL);

    return mutate;
};
